import React from "react";

import Header from "../components/Header";
import ContestantsGrid from "../components/ContestantsGrid";

import "../App.css";

function Home() {
  return (
    <div>
      <Header />
      <ContestantsGrid />
    </div>
  );
}

export default Home;
